import { Component } from '@angular/core';

@Component({
  selector: 'lib-element-footer',
  imports: [],
  templateUrl: './element-footer.html',
  styleUrl: './element-footer.css',
})
export class ElementFooter {

}
